import styled from 'styled-components';

const StyledRowCard = styled.div`
  background-color: gray;
  height: 260px;
  width: calc(50% - 16px);
  border-radius: 12px;

  .fr-row-card {
    width: 100%;

    &__loading-container {
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
    }

    &__content {
      border-radius: 12px;
      width: 100%;
      background-size: cover;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      position: relative;

      &__title {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 16px;
        margin-bottom: 40px;
      }

      &__bottom {
        position: absolute;
        width: calc(100% - 32px);
        left: 16px;
        bottom: 16px;
        align-items: center;
        justify-content: space-between;
      }
    }
  }
`;

export default StyledRowCard;
